module.exports = __webpack_public_path__ + "img/download.939a28d4.svg";